import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../default-settings-service.service';
import {isLineBreak} from 'codelyzer/angular/sourceMappingVisitor';
import {ExcTab} from 'exc-tab';
import {AuditDetailsComponent} from '../audit-details/audit-details.component';
import {SearchSlimData} from '../search-slim/search-slim.component';
import {ExcSigninService} from 'exc-signin';

@Component({
  selector: 'kanban-item',
  templateUrl: './kanban-item.component.html',
  styles: []
})
export class KanbanItemComponent extends ExcTranslation implements  OnInit {

  @Input('item') item;
  @Input('lane') lane;
  @Output() onAction: EventEmitter<KanbanItemAction> = new EventEmitter<KanbanItemAction>();
  constructor(private excDss: DefaultSettingsService, private excSec: ExcSigninService) {
    super();
  }
  getTimeRemaining() {
    if (this.lane !== 2) {
      return '';
    }
    const h = Math.floor(this.item.AuditMinutesRemaining / 60);
    const m = this.item.AuditMinutesRemaining % 60;

    return h + 'h ' + m + 'm';
  }
  getCalendarIcon() {
      if (this.item.AuditFinalMailSent === true) {
        return 'fa-calendar-check ';
      } else if (this.item.AuditFirstMailSent === true) {
        return 'fa-calendar-star ';
      } else {
        return 'fa-calendar';
      }
  }
  emitAction(action) {
    this.onAction.emit(new KanbanItemAction(this.item, action));
  }
  openAudit(x) {
    new ExcTab(x.AuditID, AuditDetailsComponent, x, x.AuditID, {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }
  getAvatarTip() {
    return '';
  }
  ngOnInit() {
  }

  adoptResults() {
    console.log('shareResults');
    if( 'Results' === null)
    {
      console.log('False');
    }
  }
}
export class KanbanItemAction {
  public Item: {AuditID: any} = null;
  public Action: string = null;
  constructor(Item, Action) {
    this.Item = Item;
    this.Action = Action;
  }
}
